import React, { useEffect, useState } from "react";
import { Button, Col, Flex, Form, Input, Row, Select, Typography } from "antd";
import { CheckOutlined } from "@ant-design/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus, faUser } from "@fortawesome/free-solid-svg-icons";
const { Option } = Select;

const { Title, Text } = Typography;

export const EmailFlyerDetails = () => {
  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 24 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 24 },
    },
  };
  const tailFormItemLayout = {
    wrapperCol: {
      xs: {
        span: 24,
        offset: 0,
      },
      sm: {
        span: 24,
        offset: 0,
      },
    },
  };
  const [form] = Form.useForm();
  const onFinish = (values: any) => {
    console.log("Received values of form: ", values);
  };
  const logoAlignmentOption = [
    { label: "Left", value: "left" },
    { label: "Center", value: "center" },
    { label: "Right", value: "right" },
  ];
  const [value1, setValue1] = useState("left");

  return (
    <>
      <Row gutter={[16, 16]}>
        <Col xs={12}>
          <div className="border-8 bg-text font-14 w-100 p-4 mb-3">
            <Title level={5} className="font-weight-400 mt-2 mb-1">
              <Flex justify="space-between">
                <span>Email ID 1* :</span>
                <span></span>
              </Flex>
            </Title>

            <Title level={5} className="font-weight-400 mt-2 mb-1">
              <Flex justify="space-between">
                <span>Email ID 2* :</span>
                <span></span>
              </Flex>
            </Title>
          </div>
        </Col>

        <Col xs={12}>
          <div className="border-8 bg-text font-14 w-100 p-4 mb-3">
            <Title level={5} className="font-weight-400 mt-2 mb-1">
              <Flex justify="space-between">
                <span>Contact Number* :</span>
                <span></span>
              </Flex>
            </Title>

            <Title level={5} className="font-weight-400 mt-2 mb-1">
              <Flex justify="space-between">
                <span>Contact Number 1* :</span>
                <span></span>
              </Flex>
            </Title>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default EmailFlyerDetails;
